export function getValidTaxEventOptions(taxType: string | null | undefined): string[] {
    if (!taxType) return [];
    const upperTaxType = taxType.toUpperCase();
    if (upperTaxType === 'IVA') {
        return ['EX', 'ISP', 'NS', 'INTRA.', 'EXPORT.'];
    }
    if (upperTaxType === 'IGIC') {
        return ['Art. 50', 'Art. 11', 'Art. 12', 'Art. 13', 'Art. 25', 'Art. 47', 'Art. 110', 'Otros'];
    }
    return [];
}

export function isInvoiceIncomplete(invoice, selectedSequence, invoiceable_type , feature_facturae_allow_lines_at_zero, feature_invoice_date_editable = true) {
    const isEmpty = (value) => ['', null, undefined].includes(value);

    // Array to store validation error messages
    const errors: string[] = [];

    function isDueDateBeforeTodayWithoutDateEditable(invoice_due_date, has_feature_invoice_date_editable, errors = null) {
        // Si tiene el permiso de editar fecha, no validamos (puede poner la fecha que quiera)
        if (has_feature_invoice_date_editable) {
            return false;
        }
        // Si no tiene fecha de vencimiento, no hay problema (se validará por otro lado si es requerida)
        if (!invoice_due_date) {
            return false;
        }
        // Si no tiene el permiso, al firmar se pone fecha de hoy, así que la fecha de vencimiento no puede ser anterior
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dueDate = new Date(invoice_due_date);
        dueDate.setHours(0, 0, 0, 0);
        const isBeforeToday = dueDate < today;

        if (isBeforeToday && errors) {
            errors.push('La fecha de vencimiento no puede ser anterior a hoy.');
        }

        return isBeforeToday;
    }

    function isValidTaxEvent(taxEvent, taxType) {
        if (!taxEvent) return false;
        const validOptions = getValidTaxEventOptions(taxType);
        return validOptions.includes(taxEvent);
    }

    function areInvoiceLinesValid(lines, feat_lines_0){
        for (let i=0; i<lines.length; i++){
            if (!lines[i].iamvalid(feat_lines_0)){
                return false
            }
        }
        return true
    }

    function areTaxEventsValid(lines, taxType) {
        for (let i=0; i<lines.length; i++){
            if (lines[i].selected_tax == 0 || lines[i].selected_tax == 0.0) {
                if (!isValidTaxEvent(lines[i].selected_tax_event, taxType)) {
                    return false;
                }
            }
        }
        return true
    }
    function isReimbursableExpense(reimbursable_expense_concept, reimbursable_amounts){
        if (reimbursable_amounts.length>0 || reimbursable_expense_concept){
            return true
        }
        return false
    }

    if (invoiceable_type != 'ticket') {
        if (
            (isEmpty(invoice.invoice_number) && isEmpty(invoice.predicted_invoice_number) && isEmpty(invoice.predicted_rectificative_invoice_number)) ||
            // No validar invoice_date si está en draft (se setea al firmar)
            // isEmpty(invoice.invoice_date) ||
            (!invoice.rectificative && !isEmpty(selectedSequence.min_inv_date) && !isEmpty(invoice.invoice_date) && invoice.invoice_date < selectedSequence.min_inv_date) ||
            (invoice.rectificative && !isEmpty(selectedSequence.min_rectificative_inv_date) && !isEmpty(invoice.invoice_date) && invoice.invoice_date < selectedSequence.min_rectificative_inv_date) ||
            (
                invoiceable_type == 'invoice' &&
                (
                    isEmpty(invoice.invoice_due_date)||
                    invoice.payment_means == '00' ||
                    isEmpty(invoice.payment_means)
                )
            ) ||
            // Si no tiene permiso de editar fecha y la fecha de vencimiento es anterior a hoy, es incompleta
            (invoiceable_type == 'invoice' && isDueDateBeforeTodayWithoutDateEditable(invoice.invoice_due_date, feature_invoice_date_editable, errors)) ||
            invoice.lines.length == 0 ||
            !isReimbursableExpense(invoice.reimbursable_expense_concept, invoice.reimbursable_amounts) && !areInvoiceLinesValid(invoice.lines, feature_facturae_allow_lines_at_zero) ||
            !areTaxEventsValid(invoice.lines, invoice.tax_type) ||
            isPartyIncomplete(invoice.supplier) || isPartyIncomplete(invoice.customer)
        ) {
            return { isIncomplete: true, errors };
        }
        return { isIncomplete: false, errors };
    } else {
        if (
            (isEmpty(invoice.invoice_number) && isEmpty(invoice.predicted_invoice_number) && isEmpty(invoice.predicted_rectificative_invoice_number)) ||
            // No validar invoice_date si está en draft (se setea al firmar)
            // isEmpty(invoice.invoice_date) ||
            (!invoice.rectificative && !isEmpty(selectedSequence.min_inv_date) && !isEmpty(invoice.invoice_date) && invoice.invoice_date < selectedSequence.min_inv_date) ||
            (invoice.rectificative && !isEmpty(selectedSequence.min_rectificative_inv_date) && !isEmpty(invoice.invoice_date) && invoice.invoice_date < selectedSequence.min_rectificative_inv_date) ||
            (
                invoiceable_type == 'invoice' &&
                (
                    isEmpty(invoice.invoice_due_date)||
                    invoice.payment_means == '00' ||
                    isEmpty(invoice.payment_means)
                )
            ) ||
            // Si no tiene permiso de editar fecha y la fecha de vencimiento es anterior a hoy, es incompleta
            (invoiceable_type == 'ticket' && isDueDateBeforeTodayWithoutDateEditable(invoice.invoice_due_date, feature_invoice_date_editable, errors)) ||
            invoice.lines.length == 0 ||
            !isReimbursableExpense(invoice.reimbursable_expense_concept, invoice.reimbursable_amounts) && !areInvoiceLinesValid(invoice.lines, feature_facturae_allow_lines_at_zero) ||
            !areTaxEventsValid(invoice.lines, invoice.tax_type) ||
            isPartyIncomplete(invoice.supplier) // quitamos la comprobación de si está relleno el receptor en caso de que sea una factura simplificada (ticket)
        ) {
            return { isIncomplete: true, errors };
        }
        return { isIncomplete: false, errors };
    }
}

export function isConfigurationOK(invoice, selectedSequence, allSequences = null, invoiceableType = 'invoice'){
    if (!selectedSequence.id) {
        return false
    }

    // Validar que el código de secuencia no esté vacío
    if (!selectedSequence.code || !selectedSequence.code.trim()) {
        return false
    }

    // Validar que el fill esté definido y no sea vacío
    if (selectedSequence.fill === undefined || selectedSequence.fill === null || selectedSequence.fill.toString().trim() === '') {
        return false
    }

    // Calcular el próximo número basado en current
    const nextNumber = selectedSequence.current + 1

    // Validar que el próximo número sea mayor que 0
    if (!nextNumber || nextNumber <= 0) {
        return false
    }

    // Validar que el próximo número sea mayor que el mínimo permitido
    if (selectedSequence.min_number !== -1 && nextNumber <= selectedSequence.min_number) {
        return false
    }

    // Si es una factura rectificativa, validar también campos rectificativos
    if (invoice.rectificative) {
        // Validar que el fill rectificativo esté definido y no sea vacío
        if (selectedSequence.rectificative_fill === undefined ||
            selectedSequence.rectificative_fill === null ||
            selectedSequence.rectificative_fill.toString().trim() === '') {
            return false
        }

        // Validar que el código rectificativo no esté vacío
        if (!selectedSequence.rectificative_code || !selectedSequence.rectificative_code.trim()) {
            return false
        }

        // Calcular el próximo número rectificativo basado en rectificative_current
        const nextRectificativeNumber = selectedSequence.rectificative_current + 1

        // Validar que el próximo número rectificativo sea mayor que 0
        if (!nextRectificativeNumber || nextRectificativeNumber <= 0) {
            return false
        }

        // Validar que el próximo número rectificativo sea mayor que el mínimo permitido
        if (selectedSequence.min_rectificative_number !== -1 &&
            nextRectificativeNumber <= selectedSequence.min_rectificative_number) {
            return false
        }
    }

    // Si se proporcionan todas las secuencias, validar duplicados
    if (allSequences && allSequences.length > 0) {
        // Importar las funciones de validación necesarias desde el módulo Sequence
        const { validateCodeSequences, validatePrefixSuffixSequences } = require('./Sequence')

        // Validar códigos duplicados en todas las secuencias
        const codesValid = validateCodeSequences(allSequences, invoiceableType)

        // Validar combinaciones prefix-suffix duplicadas en todas las secuencias
        const prefixSuffixValid = validatePrefixSuffixSequences(allSequences, invoiceableType)

        // Verificar si la secuencia seleccionada tiene errores marcados
        if (selectedSequence.duplicateError ||
            selectedSequence.rectDuplicateError ||
            selectedSequence.normalComboError ||
            selectedSequence.rectComboError) {
            return false
        }

        // Si las validaciones globales fallaron, retornar false
        if (!codesValid || !prefixSuffixValid) {
            return false
        }
    }

    return true
}

export function isManualInvoiceNumber(hasFeatureManualInvoiceNumber: boolean,invoice?: { name?: string }): boolean {
    return hasFeatureManualInvoiceNumber || invoice?.name === 'proforma'
}


export function isPartyIncomplete(party) {
    const isEmpty = (value) => ['', null, undefined].includes(value);

    if (!party || 
        (party && 
            (isEmpty(party.cif) ||
            isEmpty(party.type)|| 
            isEmpty(party.address) || 
            isEmpty(party.city) || 
            isEmpty(party.province) || 
            isEmpty(party.post_code) ||
            (party.type == 'juridica' && isEmpty(party.business_name)) || 
            (party.type == 'fisica' && (isEmpty(party.name) ||  isEmpty(party.first_surname))) 
            )
    )) {
        return true
    }
    return false
}

export function isValidNIF(nif: string, country?: string): boolean {
    // Only validate NIF/NIE spanish if the country is Spain (ES)
    // If no country is provided or is different from ES, it is considered valid
    if (!country || country.toUpperCase() !== 'ES') {
        return true;
    }

    // Validación de NIF/NIE español para persona física
    // El NIF consta de 8 dígitos + 1 letra de control
    // El NIE (extranjeros) empieza con X, Y o Z seguido de 7 dígitos + letra
    if (!nif) return false;

    const cleanNif = nif.toUpperCase().replace(/[^A-Z0-9]/g, '');

    const dniRegex = /^(\d{8})([A-Z])$/;
    const nieRegex = /^([XYZ])(\d{7})([A-Z])$/;

    const letras = 'TRWAGMYFPDXBNJZSQVHLCKE';

    // Comprobar si es DNI
    const dniMatch = cleanNif.match(dniRegex);
    if (dniMatch) {
        const numero = parseInt(dniMatch[1], 10);
        const letra = dniMatch[2];
        return letras[numero % 23] === letra;
    }

    // Comprobar si es NIE
    const nieMatch = cleanNif.match(nieRegex);
    if (nieMatch) {
        const niePrefix: { [key: string]: string } = { 'X': '0', 'Y': '1', 'Z': '2' };
        const numero = parseInt(niePrefix[nieMatch[1]] + nieMatch[2], 10);
        const letra = nieMatch[3];
        return letras[numero % 23] === letra;
    }

    return false;
}